import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartPie } from './useGetChartPie'
import { ChartPieContent } from './ChartPieContent'

export const ChartPieComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetChartPie(id, tileFilterSelections)

  return (
    <ChartPieContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartPieComponentLoading() {
  return 'Loading...'
}
